(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (function() {
    function getVisibleItems(container) {
      return Array.from(container.children).filter(function(child) {
        if (child.nodeType !== Node.ELEMENT_NODE) return false;
        if (child.tagName === 'STYLE' || child.tagName === 'SCRIPT') return false;
        if (child.dataset.carouselClone === 'true') return false;
        var s = window.getComputedStyle(child);
        return s.display !== 'none' && s.position !== 'absolute' && s.position !== 'fixed';
      });
    }

    function getAllScrollItems(container) {
      return Array.from(container.children).filter(function(child) {
        if (child.nodeType !== Node.ELEMENT_NODE) return false;
        if (child.tagName === 'STYLE' || child.tagName === 'SCRIPT') return false;
        var s = window.getComputedStyle(child);
        return s.display !== 'none' && s.position !== 'absolute' && s.position !== 'fixed';
      });
    }

    function setupLoop(container) {
      var originals = getVisibleItems(container);
      if (originals.length === 0) return { resetPoint: 0, update: function(){} };

      originals.forEach(function(item) {
        var clone = item.cloneNode(true);
        clone.dataset.carouselClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        container.appendChild(clone);
      });

      // Cache reset point — recompute only on resize
      var cachedResetPoint = 0;
      function computeResetPoint() {
        var lastOriginal = originals[originals.length - 1];
        var gap = parseFloat(getComputedStyle(container).gap) || 0;
        cachedResetPoint = lastOriginal.offsetLeft + lastOriginal.offsetWidth + gap - container.offsetLeft;
      }

      // Compute after layout settles
      requestAnimationFrame(computeResetPoint);
      window.addEventListener('resize', computeResetPoint);

      return {
        get resetPoint() { return cachedResetPoint; },
        update: computeResetPoint,
        checkAndReset: function() {
          if (cachedResetPoint > 0 && container.scrollLeft >= cachedResetPoint) {
            container.scrollLeft = container.scrollLeft - cachedResetPoint;
          }
        }
      };
    }

    function init() {
      document.querySelectorAll('[data-carousel-autoplay], [data-carousel-loop]').forEach(function(container) {
        if (container._carouselInit) return;
        container._carouselInit = true;

        var mode = container.dataset.carouselAutoplay || '';
        var loop = container.dataset.carouselLoop === 'true';
        var hasAutoplay = mode === 'seamless' || mode === 'intervals';
        var loopCtrl = null;

        // Disable scroll-behavior so resets are always instant
        container.style.scrollBehavior = 'auto';

        // Set up loop clones first
        if (loop) {
          loopCtrl = setupLoop(container);
        }

        var paused = false;
        var pauseOnHover = container.dataset.carouselPauseOnHover === 'true';

        // Pause on hover
        if (pauseOnHover && hasAutoplay) {
          container.addEventListener('mouseenter', function() { paused = true; });
          container.addEventListener('mouseleave', function() { paused = false; });
        }

        // Always attach scroll listener for loop reset (works for both autoplay and manual scroll)
        if (loop && loopCtrl) {
          container.addEventListener('scroll', function() {
            loopCtrl.checkAndReset();
          }, { passive: true });
        }

        // Seamless mode
        if (mode === 'seamless') {
          // Speed levels 1-10: pixels per second (fixed rate, independent of content width)
          var pxPerSecMap = [20, 35, 50, 75, 100, 140, 200, 300, 450, 600];
          var speedLevel = parseInt(container.dataset.carouselSpeed) || 3;
          var pxPerSec = pxPerSecMap[Math.min(Math.max(speedLevel, 1), 10) - 1] || 35;
          var running = true;

          function seamlessStep() {
            if (!running) return;
            if (paused) { requestAnimationFrame(seamlessStep); return; }
            var totalScroll = container.scrollWidth - container.clientWidth;
            if (totalScroll <= 0) { requestAnimationFrame(seamlessStep); return; }
            var pxPerFrame = pxPerSec / 60;

            if (loop && loopCtrl) {
              loopCtrl.checkAndReset();
            }

            if (!loop && container.scrollLeft + container.clientWidth >= container.scrollWidth - 5) {
              running = false;
              return;
            }

            container.scrollLeft += pxPerFrame;
            requestAnimationFrame(seamlessStep);
          }
          requestAnimationFrame(seamlessStep);
        }

        // Intervals mode
        if (mode === 'intervals') {
          var intervalMs = (parseInt(container.dataset.carouselInterval) || 3) * 1000;

          function advanceSlide() {
            if (paused) return;
            var items = getAllScrollItems(container);
            if (items.length === 0) return;

            if (loop && loopCtrl) {
              loopCtrl.checkAndReset();
            }

            if (!loop && container.scrollLeft + container.clientWidth >= container.scrollWidth - 5) {
              return;
            }

            var itemWidth = items[0].offsetWidth;
            var gap = 0;
            if (items.length > 1) {
              gap = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().right;
            }
            var step = itemWidth + gap;
            container.scrollTo({ left: container.scrollLeft + step, behavior: 'smooth' });
          }
          setInterval(advanceSlide, intervalMs);
        }
      });
    }

    init();
    document.addEventListener('shopify:section:load', init);

    /* Carousel fade edge scroll detection */
    function initFade() {
      document.querySelectorAll('.section--carousel-fade-desktop .custom-section-content, .section--carousel-fade-mobile .custom-section-content').forEach(function(wrapper) {
        if (wrapper._fadeInit) return;
        wrapper._fadeInit = true;
        var scroller = wrapper.querySelector('.section-content-wrapper');
        if (!scroller) return;

        function check() {
          var atStart = scroller.scrollLeft <= 5;
          var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 5;
          if (atStart) { wrapper.removeAttribute('data-fade-start'); } else { wrapper.setAttribute('data-fade-start', ''); }
          wrapper.setAttribute('data-fade-end', atEnd ? 'false' : 'true');
        }

        scroller.addEventListener('scroll', check, { passive: true });
        check();
      });
    }

    initFade();
    document.addEventListener('shopify:section:load', initFade);
  })();
  } catch(e) { console.error(e); }
})();

})();
